import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-annule-bon-sortie-negoce',
  templateUrl: './annule-bon-sortie-negoce.component.html',
  styleUrls: ['./annule-bon-sortie-negoce.component.scss']
})
export class AnnuleBonSortieNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
